"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchRewardsOverlay = MatchRewardsOverlay;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const BalanceIcon_1 = require("~/components/ui/icon/BalanceIcon");
const LevelIcon_1 = require("~/components/ui/icon/LevelIcon");
const player_1 = require("~/components/ui/player");
const PositionChip_1 = require("~/components/ui/player/PositionChip");
const plugins_1 = require("~/plugins");
const players_1 = require("~/store/game/players");
const useStyles_1 = require("~/useStyles");
const MatchIncomeReport_1 = require("../../MatchIncomeReport");
const playerList_1 = require("../../playerList");
const boardOverlay_1 = require("./boardOverlay");
const quickChat_1 = require("./quickChat");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    root: {
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "width": "100%",
        "gap": "16px",
        "@media (orientation: portrait) and (min-width: 431px)": {
            gap: "32px",
        },
    },
    desktopOnly: {
        "display": "none",
        "padding": "0px 20px",
        "@media (orientation: portrait) and (max-width: 431px)": {
            display: "inline",
        },
    },
    wrapper: {
        textAlign: "center",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        background: "#566c86",
        border: "2px solid #b13e53",
        fontFamily: theme.typography.primary,
    },
    vsHeader: {
        "borderTop": "2px solid #b13e53",
        "borderBottom": "2px solid #b13e53",
        "padding": "8px 0",
        "@media (orientation: portrait) and (max-width: 430px)": {
            padding: "2px 0",
            display: "none",
        },
        "& > h2": {
            margin: 0,
        },
    },
    badges: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        boxSizing: "border-box",
        alignItems: "center",
    },
    cloneTag: {
        background: "#333333",
        marginLeft: "0.5em",
        padding: "0 0.5em",
        fontStyle: "italic",
    },
    healthbar: {
        margin: 0,
    },
    playerDetails: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flex: 2,
        gap: "4px",
    },
    playerAvatar: {
        flex: 1,
    },
    opponent: {
        "display": "flex",
        "flexDirection": "row",
        "padding": "8px",
        "borderBottom": "2px solid #b13e53",
        "@media (orientation: portrait) and (max-width: 430px)": {
            padding: "4px",
        },
    },
    nameWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "8px",
    },
    playerName: {
        fontSize: "12px",
    },
    tags: {
        display: "flex",
        flexDirection: "row",
        gap: "4px",
    },
    title: {
        "textAlign": "left",
        "padding": "4px 8px",
        "fontFamily": theme.typography.accent,
        "fontSize": "36px",
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "16px",
        },
    },
    income: {
        flex: 3,
    },
    damage: {
        "flex": 1,
        "display": "flex",
        "flexDirection": "row",
        "justifyContent": "center",
        "alignItems": "center",
        "& > span": {
            "padding": "8px 16px",
            "fontSize": "36px",
            "fontWeight": 700,
            // todo same colours and border as the piece count warning
            "color": "#ff6464",
            "background": "#ffd2d2",
            "border": "2px solid #ff6464",
            "@media (orientation: portrait) and (max-width: 430px)": {
                padding: "2px 4px",
                fontSize: "16px",
            },
        },
    },
    outcomes: {
        background: "#30364b",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    deathMessage: {
        "flex": 1,
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "gap": "24px",
        "padding": "0 8px",
        "fontSize": "18px",
        "@media (orientation: portrait) and (max-width: 430px)": {
            gap: "12px",
            fontSize: "14px",
        },
    },
    thankYou: {
        flex: 2,
    },
    jkm: {
        background: "#1d1d1d",
        fontFamily: theme.typography.accent,
        padding: "4px 8px",
        fontStyle: "italic",
    },
    spectateReminder: {
        "fontSize": "14px",
        "fontStyle": "italic",
        "@media (orientation: portrait) and (max-width: 430px)": {
            fontSize: "10px",
        },
    },
}));
function MatchRewardsOverlay() {
    var _a, _b;
    const styles = useStyles();
    const opponent = (0, players_1.useOpponentPlayer)();
    const localPlayer = (0, players_1.useLocalPlayer)();
    const opponentPosition = (0, players_1.usePlayerRank)((_a = opponent === null || opponent === void 0 ? void 0 : opponent.id) !== null && _a !== void 0 ? _a : "") || null;
    const matchRewards = (0, react_redux_1.useSelector)((state) => state.game.localPlayer.matchRewards);
    const victoryOverlayShowing = (0, react_redux_1.useSelector)((state) => state.game.ui.winnerId !== null);
    const spectatingPlayer = (0, react_redux_1.useSelector)((state) => state.game.spectating.id !== null);
    if (!matchRewards || victoryOverlayShowing || spectatingPlayer) {
        return null;
    }
    const { damage, justDied } = matchRewards;
    const title = justDied
        ? "Game Over!"
        : damage > 0
            ? "Match Lost!"
            : "Match Won!";
    if (justDied) {
        return (React.createElement(boardOverlay_1.BoardOverlay, null,
            React.createElement("div", { className: styles.root },
                React.createElement("div", { className: styles.wrapper },
                    React.createElement("div", { className: styles.title }, title),
                    React.createElement("div", { className: styles.outcomes },
                        React.createElement("div", { className: styles.deathMessage },
                            React.createElement("p", null, "You have been knocked out of this game."),
                            React.createElement("p", null,
                                "I hope you enjoyed yourself! -",
                                " ",
                                React.createElement("span", { className: styles.jkm }, "JKM")),
                            React.createElement("p", { className: styles.spectateReminder }, "Open the Player List and click a name to continue spectating.")))))));
    }
    return (React.createElement(boardOverlay_1.BoardOverlay, null,
        React.createElement("div", { className: styles.root },
            React.createElement(plugins_1.Region, { cls: "overlay-content", id: "overlay.content", ctx: { localPlayerId: localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.id } },
                React.createElement("div", { className: styles.wrapper },
                    React.createElement("div", { className: styles.title },
                        title,
                        " ",
                        React.createElement("div", { className: styles.desktopOnly }, "vs")),
                    opponent && opponentPosition && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: styles.vsHeader }, "vs."),
                        React.createElement("div", { className: styles.opponent },
                            React.createElement("div", { className: styles.playerAvatar },
                                React.createElement(plugins_1.Region, { cls: "player-avatar", id: "player.avatar.opponent", ctx: { playerId: opponent.id } },
                                    React.createElement(player_1.PlayerAvatar, { player: opponent })),
                                React.createElement(quickChat_1.QuickChatBox, { playerId: opponent.id })),
                            React.createElement("div", { className: styles.playerDetails },
                                React.createElement("div", { className: styles.nameWrapper },
                                    React.createElement("span", { className: styles.playerName }, opponent.name),
                                    React.createElement("div", { className: styles.tags },
                                        React.createElement(PositionChip_1.PositionChip, { position: opponentPosition }))),
                                React.createElement(player_1.Title, { title: ((_b = opponent.profile) === null || _b === void 0 ? void 0 : _b.title) || null }),
                                React.createElement(player_1.PlayerHealthbar, { health: opponent.health }),
                                React.createElement("div", { className: styles.badges },
                                    React.createElement(playerList_1.StreakIndicator, { type: opponent.streakType, amount: opponent.streakAmount }),
                                    React.createElement(BalanceIcon_1.BalanceIcon, { amount: opponent.money }),
                                    React.createElement(LevelIcon_1.LevelIcon, { amount: opponent.level })))))),
                    React.createElement("div", { className: styles.outcomes },
                        damage > 0 && (React.createElement("div", { className: styles.damage },
                            React.createElement("span", null,
                                damage,
                                " health lost!"))),
                        React.createElement(plugins_1.Region, { cls: "match-rewards-summary", id: "match-rewards.summary", ctx: { rewards: matchRewards } },
                            React.createElement(MatchIncomeReport_1.MatchIncomeReport, { rewards: matchRewards, className: styles.income }))))),
            localPlayer && (React.createElement(quickChat_1.QuickChatButtonArray, { playerId: localPlayer.id })))));
}
